import React from 'react';
import PropTypes from 'prop-types';
import styles from './Tooltip.module.scss';

const placements = {
    top: styles.top,
    right: styles.right,
    bottom: styles.bottom,
    left: styles.left
};

const Tooltip = ({show, placement, children}) => {

    if (!show) {
        return null;
    }

    const contentClasses = [styles.tooltipContent, placements[placement]];

    return (
        <div className={styles.tooltip}>
            <div className={contentClasses.join(' ')}>
                {children}
            </div>
        </div>
    );
};

Tooltip.propTypes = {
    placement: PropTypes.oneOf(Object.keys(placements)),
    show: PropTypes.bool,
    children: PropTypes.any,
};

Tooltip.defaultProps = {
    placement: 'top',
    show: false,
    children: null
};

export default Tooltip;
